import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { EstadoIA, IaService } from 'src/app/services/ia/ia.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { haceCuanto, nombreCausa, puedeConfigurarIA } from 'src/app/services/ia/ia-formato';

/**
 * INTELIGENCIA ARTIFICIAL — la carcasa de `console/ia`.
 *
 * Contrato: `kredit-api-MT/modules/ia/CONTRATO.md` §8.2. Juan, 2026-09-25:
 * *«se va a configurar en IA de kredit-user, donde va a estar la clave de IA o
 * la configuración de las claves, que también pueden extenderse a los
 * comercios»*.
 *
 * 📍 Mismo molde que la ficha del comercio: el encabezado, la cinta y la barra
 * de solapas se quedan fijos, y lo de abajo entra por el `<router-outlet>`.
 * Cada solapa es una ruta hija de verdad (`console/ia`, `/agentes`,
 * `/comercios`, `/bitacora`, `/probar`): tiene su enlace, su atrás y su carga.
 *
 * 🔴 UNA SOLA CINTA, la de «la IA está apagada», y NO en la solapa Estado: ahí
 * la tarjeta del interruptor ya lo dice con su motivo, y decirlo dos veces es ruido. Es lo único que cambia el
 * sentido de todo lo de abajo: con la IA apagada, prender a un comercio no hace
 * que el botón aparezca en su portal. Si el estado no se pudo leer, la cinta no
 * se dibuja: cada solapa dice su propio error con su «Reintentar».
 */
@Component({
  selector: 'app-ia',
  templateUrl: './ia.component.html',
  styleUrls: ['./ia.component.css']
})
export class IaComponent implements OnInit, OnDestroy {

  estado: EstadoIA | null = null;
  /** En la solapa Estado la tarjeta del interruptor ya lo dice: ahí la cinta se calla. */
  enEstado = true;
  private sub?: Subscription;
  private subRuta?: Subscription;

  readonly haceCuanto = haceCuanto;
  readonly nombreCausa = nombreCausa;

  constructor(private _ia: IaService, private router: Router, private _auth: AuthService) { }

  /** Quien no configura (p. ej. un ANALIST que llegó por la dirección) mira sin tocar. */
  get soloLectura(): boolean { return !puedeConfigurarIA(this._auth); }

  ngOnInit(): void {
    this.sub = this._ia.ultimoEstado$.subscribe((e) => { this.estado = e; });
    const mirar = () => { this.enEstado = this.router.url.split('?')[0].replace(/\/+$/, '') === '/console/ia'; };
    mirar();
    this.subRuta = this.router.events
      .pipe(filter((ev): ev is NavigationEnd => ev instanceof NavigationEnd))
      .subscribe(mirar);
    // La primera lectura la hace la carcasa, para que la cinta esté en todas las
    // solapas; si falla, silencio aquí — la solapa lo dice.
    this._ia.getEstado().catch(() => { /* la solapa lo dice */ });
  }

  ngOnDestroy(): void { this.sub?.unsubscribe(); this.subRuta?.unsubscribe(); }

  get apagada(): boolean { return !!this.estado?.apagado?.apagado; }
}
